import { render, staticRenderFns } from "./LessonMasterEditor.vue?vue&type=template&id=97660844"
import script from "./LessonMasterEditor.vue?vue&type=script&lang=js"
export * from "./LessonMasterEditor.vue?vue&type=script&lang=js"
import style0 from "./LessonMasterEditor.vue?vue&type=style&index=0&id=97660844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports